import { AUTO, Game, Scale, type Types } from 'phaser';
import { GameSession, SESSION_KEY } from './game/session';
import { GAME_HEIGHT, GAME_WIDTH } from './scenes/base-scene';
import { Bootup } from './scenes/bootup';
import { HighscoresScene } from './scenes/highscores-scene';
import { Intro } from './scenes/intro';
import { MainMenu } from './scenes/main-menu';
import { PlayerSelect } from './scenes/player-select';
import { Race } from './scenes/race';
import { SettingsScene } from './scenes/settings-scene';

export const SCENES = [
  Bootup,
  Intro,
  MainMenu,
  PlayerSelect,
  SettingsScene,
  HighscoresScene,
  Race,
];

export function createGameConfig(
  overrides: Partial<Types.Core.GameConfig> = {},
): Types.Core.GameConfig {
  return {
    type: AUTO,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    parent: 'game',
    backgroundColor: '#0c0c0c',
    scale: {
      // Letterbox into whatever space the page gives us, so the 1280x720
      // layout coordinates stay valid on phones and ultrawides alike.
      mode: Scale.FIT,
      autoCenter: Scale.CENTER_BOTH,
    },
    physics: {
      default: 'arcade',
      arcade: { gravity: { x: 0, y: 0 } },
    },
    scene: SCENES,
    ...overrides,
  };
}

export function startGame(overrides: Partial<Types.Core.GameConfig> = {}): Game {
  const game = new Game(createGameConfig(overrides));
  game.registry.set(SESSION_KEY, new GameSession());
  return game;
}
